import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./TechExpertiseTabs.css";
import { Navigation } from "swiper/modules";
import arrowright from "../../assets/utility_images/arrow-right-tabs.svg";
import arrowrightDisabled from "../../assets/utility_images/tab-next-disabled.svg";
import arrowleft from "../../assets/utility_images/tab-prev-active.svg";
import arrowleftDisabled from "../../assets/utility_images/arrow-left-tabs.svg";

const TechExpertisetab = ({ t, setSelectedCategory, selectedCategory }) => {
  const [showArrows, setShowArrows] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [swiperInstance, setSwiperInstance] = useState(null); // Store Swiper instance
  const totalSlides = 6;

  const breakpoints = {
    350: { slidesPerView: 2 },
    576: { slidesPerView: 3 },
    768: { slidesPerView: 4 },
    1100: { slidesPerView: 5 },
  };

  const handleTabClick = (category, index) => {
    setSelectedCategory(category);
    if (swiperInstance) {
      swiperInstance.slideTo(index); // Move Swiper to the clicked tab
    }
  };

  useEffect(() => {
    const updateArrowVisibility = () => {
      const viewportWidth = window.innerWidth;
      let slidesPerView = totalSlides;

      for (const [key, value] of Object.entries(breakpoints)) {
        if (viewportWidth <= key) {
          slidesPerView = value.slidesPerView;
          break;
        }
      }

      setShowArrows(totalSlides > slidesPerView);
    };

    updateArrowVisibility();
    window.addEventListener("resize", updateArrowVisibility);

    return () => window.removeEventListener("resize", updateArrowVisibility);
  }, []);

  const handleSwiperUpdate = (swiper) => {
    setIsPrevDisabled(swiper.isBeginning);
    setIsNextDisabled(swiper.isEnd);
  };

  return (
    <div className="tabs-carousel">
      <button
        className={`custom-prev ${!showArrows ? "hidden" : ""}`}
        id="custom-prev"
        disabled={isPrevDisabled}
      >
        <div className="tabs-arrow">
          <img
            src={isPrevDisabled ? arrowleftDisabled : arrowleft}
            alt={isPrevDisabled ? "Prev Disabled" : "Prev"}
            loading="lazy"
          />
        </div>
      </button>
      <button
        className={`custom-next ${!showArrows ? "hidden" : ""}`}
        id="custom-next"
        disabled={isNextDisabled}
      >
        <div className="tabs-arrow">
          <img
            src={isNextDisabled ? arrowrightDisabled : arrowright}
            alt={isNextDisabled ? "Next Disabled" : "Next"}
            loading="lazy"
          />
        </div>
      </button>

      <Swiper
        modules={[Navigation]}
        navigation={{
          prevEl: "#custom-prev",
          nextEl: "#custom-next",
        }}
        slidesPerView={3}
        spaceBetween={10}
        speed={600}
        breakpoints={breakpoints}
        onUpdate={handleSwiperUpdate} // Triggered on Swiper state changes
        onSlideChange={handleSwiperUpdate} // Triggered on slide change
        onSwiper={setSwiperInstance} // Capture Swiper instance
      >
        {[
          { category: "vision and image processing", label: t.visionandimageProcessing },
          { category: "crm", label: t.crm },
          { category: "cloud", label: t.cloud },
          { category: "mobile", label: t.mobile },
          { category: "software", label: t.software },
          // { category: "chipsetexpertise", label: t.chipsetExpertise },
          // { category: "qa", label: t.qa },
        ].map((slide, index) => (
          <SwiperSlide key={slide.category}>
            <button
              className={`tab-link ${
                selectedCategory === slide.category ? "active" : ""
              }`}
              onClick={() => handleTabClick(slide.category, index)}
            >
              {slide.label}
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TechExpertisetab;
